module.exports = "/static/media/invite_icon.0dbeaffc.svg";